'use strict';

const angular = require('angular');
const uiRouter = require('angular-ui-router');
const _ = require('lodash');
import routes from './order.routes';

import ExportModalController from './export.modal.controller';

export class OrderComponent {

  constructor($scope, $http, $q, $state, $stateParams, $timeout, $filter, $uibModal, Auth, Modal, Util) {
    'ngInject';

    this.$scope = $scope;
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.Modal = Modal;
    this.Util = Util;

    this.user;

    this.isAdd = true;
    this.submitted = false;
    this.form = {
      // inforRequisition: null,
      // companyGL: null,
      // companyGLRef: null,
      // companyGLIsNew: false,
      // accountingUnit: null,
      // accountingUnitRef: null,
      // accountingUnitIsNew: false,
      // locationCode: null,
      // locationCodeRef: null,
      // locationCodeIsNew: false,
    };
    this.isSaving = false;
    this.showCreatedSuccessMsg = false;
    this.showUpdatedSuccessMsg = false;

    this.companyGLOptions = [];
    this.accountingUnits = [];
    this.locationCodes = [];

    this.lengthOptions = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26
    ];
    this.lengthTypeOptions = [
      'Days', 'Weeks'
    ];
    this.timeOptions = [
      '12:00 AM', '12:15 AM', '12:30 AM', '12:45 AM',
      '1:00 AM', '1:15 AM', '1:30 AM', '1:45 AM',
      '2:00 AM', '2:15 AM', '2:30 AM', '2:45 AM',
      '3:00 AM', '3:15 AM', '3:30 AM', '3:45 AM',
      '4:00 AM', '4:15 AM', '4:30 AM', '4:45 AM',
      '5:00 AM', '5:15 AM', '5:30 AM', '5:45 AM',
      '6:00 AM', '6:15 AM', '6:30 AM', '6:45 AM',
      '7:00 AM', '7:15 AM', '7:30 AM', '7:45 AM',
      '8:00 AM', '8:15 AM', '8:30 AM', '8:45 AM',
      '9:00 AM', '9:15 AM', '9:30 AM', '9:45 AM',
      '10:00 AM', '10:15 AM', '10:30 AM', '10:45 AM',
      '11:00 AM', '11:15 AM', '11:30 AM', '11:45 AM',
      '12:00 PM', '12:15 PM', '12:30 PM', '12:45 PM',
      '1:00 PM', '1:15 PM', '1:30 PM', '1:45 PM',
      '2:00 PM', '2:15 PM', '2:30 PM', '2:45 PM',
      '3:00 PM', '3:15 PM', '3:30 PM', '3:45 PM',
      '4:00 PM', '4:15 PM', '4:30 PM', '4:45 PM',
      '5:00 PM', '5:15 PM', '5:30 PM', '5:45 PM',
      '6:00 PM', '6:15 PM', '6:30 PM', '6:45 PM',
      '7:00 PM', '7:15 PM', '7:30 PM', '7:45 PM',
      '8:00 PM', '8:15 PM', '8:30 PM', '8:45 PM',
      '9:00 PM', '9:15 PM', '9:30 PM', '9:45 PM',
      '10:00 PM', '10:15 PM', '10:30 PM', '10:45 PM',
      '11:00 PM', '11:15 PM', '11:30 PM', '11:45 PM'
    ];
    this.incentiveOptions = [
      '$0', '$1', '$2', '$3', '$4', '$5', 'Submit Required Rate'
    ];
    this.yearsExperienceOptions = [
      '0', '1', '2', '3', '4', '5+'
    ];
    this.yesNoOptions = [
      'Yes', 'No'
    ];
  }

  getCompanyGLs(extraParams) {
    let deferred = this.$q.defer();
    let self = this;
    let params = {
      _pageSize: 'All',
      _selector: 'companyName,gl',
      _sortBy: 'gl asc'
    };
    if(extraParams) {
      angular.extend(params, extraParams);
    }
    this.$http.get(`/api/types/companies/gls`, { params: params })
      .then(function(response) {
        self.companyGLOptions = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  getAccountingUnits(extraParams) {
    let deferred = this.$q.defer();
    let self = this;
    let params = {
      _pageSize: 'All',
      _selector: 'hrOrganizationUnit,shortDescription,description,parentUnitShortDescription,mvsOrBsc',
      _sortBy: 'hrOrganizationUnit asc'
    };
    if(extraParams) {
      angular.extend(params, extraParams);
    }
    this.$http.get(`/api/types/companies/accountingUnits`, { params: params })
      .then(function(response) {
        self.accountingUnits = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  getLocationCodes(extraParams) {
    let deferred = this.$q.defer();
    let self = this;
    let params = {
      _pageSize: 'All',
      _selector: 'hrLocation,description,mvsOrBsc',
      _sortBy: 'hrLocation asc'
    };
    if(extraParams) {
      angular.extend(params, extraParams);
    }
    this.$http.get(`/api/types/companies/locationCodes`, { params: params })
      .then(function(response) {
        self.locationCodes = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  noPad(n, size) {
    var s = String(n);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  getData(id) {
    let deferred = this.$q.defer();
    let self = this;
    this.$http.get(`/api/orders/${id}`)
      .then(function(response) {
        if(response.data.orderNo) {
          response.data._orderNo = self.noPad(response.data.orderNo, 5);
        }
        if(response.data.assignmentStartDate) {
          response.data.assignmentStartDate = new Date(response.data.assignmentStartDate);
        }
        if(response.data.assignmentLength) {
          response.data.assignmentLength = parseInt(response.data.assignmentLength);
        }
        if(response.data.credentialRequirements) {
          let credentialRequirements = response.data.credentialRequirements.split(', ');
          angular.forEach(credentialRequirements, function(cred) {
            if(cred === 'ACLS') {
              response.data.credentialRequirement_acls = true;
            } else if(cred === 'AWHONN') {
              response.data.credentialRequirement_awhonn = true;
            } else if(cred === 'BLS') {
              response.data.credentialRequirement_bls = true;
            } else if(cred === 'EKG') {
              response.data.credentialRequirement_ekg = true;
            } else if(cred === 'NIH') {
              response.data.credentialRequirement_nih = true;
            } else if(cred === 'NRP') {
              response.data.credentialRequirement_nrp = true;
            } else if(cred === 'NVCI') {
              response.data.credentialRequirement_nvci = true;
            } else if(cred === 'ONC') {
              response.data.credentialRequirement_onc = true;
            } else if(cred === 'PALS') {
              response.data.credentialRequirement_pals = true;
            } else if(cred === 'TNCC') {
              response.data.credentialRequirement_tncc = true;
            }
          });
        }
        self.form = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  update(id, payload) {
    let self = this;
    this.$http.put(`/api/orders/${id}`, payload)
      .then(function(response) {
        self.showUpdatedSuccessMsg = true;
        self.$timeout(function() {
          self.showUpdatedSuccessMsg = false;
          self.$state.go('main');
        }, 5000);
      }, function(err) {
        self.isSaving = false;
      });
  }

  create(payload) {
    let self = this;
    this.$http.post('/api/orders', payload)
      .then(function(response) {
        //self.Util.scrollToTop();
        self.showCreatedSuccessMsg = true;
        self.$timeout(function() {
          self.showCreatedSuccessMsg = false;
          self.$state.go('main');
        }, 5000);
      }, function(err) {
        self.isSaving = false;
      });
  }

  submitForm(form) {
    let self = this;
    this.submitted = true;
    if(form.$valid && self.form.companyGLRef && self.form.accountingUnitRef && self.form.locationCodeRef && self.form.jobClassRef) {
      self.isSaving = true;
      if(self.form.assignmentStartDate) {
        self.form.assignmentStartDateStr = self.$filter('date')(self.form.assignmentStartDate, 'MM/dd/yyyy');
      }
      let credentialRequirements = [];
      if(self.form.credentialRequirement_acls) {
        credentialRequirements.push('ACLS');
      }
      if(self.form.credentialRequirement_awhonn) {
        credentialRequirements.push('AWHONN');
      }
      if(self.form.credentialRequirement_bls) {
        credentialRequirements.push('BLS');
      }
      if(self.form.credentialRequirement_ekg) {
        credentialRequirements.push('EKG');
      }
      if(self.form.credentialRequirement_nih) {
        credentialRequirements.push('NIH');
      }
      if(self.form.credentialRequirement_nrp) {
        credentialRequirements.push('NRP');
      }
      if(self.form.credentialRequirement_nvci) {
        credentialRequirements.push('NVCI');
      }
      if(self.form.credentialRequirement_onc) {
        credentialRequirements.push('ONC');
      }
      if(self.form.credentialRequirement_pals) {
        credentialRequirements.push('PALS');
      }
      if(self.form.credentialRequirement_tncc) {
        credentialRequirements.push('TNCC');
      }
      if(credentialRequirements.length) {
        self.form.credentialRequirements = credentialRequirements.join(', ');
      }
      if(!self.isAdd) {
        self.update(self.form._id, self.form);
      } else {
        self.create(self.form);
      }
    }
  }

  delete() {
    let self = this;
    this.Modal.confirm.delete(function() {

    })('order');
  }

  /* 
   * Autocomplete
   */

  // Company GL

  companyGL_formatter(items) {
    let formattedItems = [];
    let i;
    for(i in items) {
      formattedItems.push({
        id: items[i]._id,
        title: items[i].gl + ' / ' + items[i].regionName + ' / ' + items[i].companyName
      });
    }
    return formattedItems;
  }

  companyGL_showAll(id) {
    this.$scope.$broadcast('autocomplete:showAll', id);
  }

  companyGL_onChanged(input) {
    this.$parent.OrderCtrl.form.companyGL = input;
  }

  companyGL_onSelected(selected) {
    if(selected) {
      if(this.$parent.OrderCtrl.form.companyGLIsNew) {
        this.$parent.OrderCtrl.form.companyGLIsNew = false;
      }

      this.$parent.OrderCtrl.form.companyGL = selected.title;
      this.$parent.OrderCtrl.form.companyGLRef = selected.originalObject.id;
    }
  }

  companyGL_clearInput(id) {
    this.$scope.$broadcast('autocomplete:clearInput', id);
    this.form.companyGL = null;
    this.form.companyGLRef = null;
  }

  // Accounting Unit

  accountingUnit_formatter(items) {
    try {
      let formattedItems = [];
      let i;
      let titles = [];
      for(i in items) {
        titles = [];
        if(items[i].hrOrganizationUnit) {
          titles.push(items[i].hrOrganizationUnit);
        }
        if(items[i].shortDescription) {
          titles.push(items[i].shortDescription);
        }
        if(items[i].description) {
          titles.push(items[i].description);
        }
        if(items[i].parentUnitShortDescription) {
          titles.push(items[i].parentUnitShortDescription);
        }
        formattedItems.push({
          id: items[i]._id,
          title: titles.join(' / ')
        });
      }
      return formattedItems;
    } catch(err) {
      console.log(err);
      return;
    }
  }

  accountingUnit_showAll(id) {
    this.$scope.$broadcast('autocomplete:showAll', id);
  }

  accountingUnit_onChanged(input) {
    this.$parent.OrderCtrl.form.accountingUnit = input;
  }

  accountingUnit_onSelected(selected) {
    if(selected) {
      if(this.$parent.OrderCtrl.form.accountingUnitIsNew) {
        this.$parent.OrderCtrl.form.accountingUnitIsNew = false;
      }

      this.$parent.OrderCtrl.form.accountingUnit = selected.title;
      this.$parent.OrderCtrl.form.accountingUnitRef = selected.originalObject.id;
    }
  }

  accountingUnit_clearInput(id) {
    this.$scope.$broadcast('autocomplete:clearInput', id);
    this.form.accountingUnit = null;
    this.form.accountingUnitRef = null;
  }

  // Location Code

  locationCode_formatter(items) {
    try {
      let formattedItems = [];
      let i;
      let titles = [];
      for(i in items) {
        titles = [];
        if(items[i].hrLocation) {
          titles.push(items[i].hrLocation);
        }
        if(items[i].description) {
          titles.push(items[i].description);
        }
        formattedItems.push({
          id: items[i]._id,
          hrLocation: items[i].hrLocation,
          title: titles.join(' / ')
        });
      }
      return formattedItems;
    } catch(err) {
      console.log(err);
      return;
    }
  }

  locationCode_showAll(id) {
    this.$scope.$broadcast('autocomplete:showAll', id);
  }

  locationCode_onChanged(input) {
    this.$parent.OrderCtrl.form.locationCode = input;
  }

  locationCode_onSelected(selected) {
    if(selected) {
      if(this.$parent.OrderCtrl.form.locationCodeIsNew) {
        this.$parent.OrderCtrl.form.locationCodeIsNew = false;
      }

      this.$parent.OrderCtrl.form.locationCode = selected.title;
      this.$parent.OrderCtrl.form.locationCodeRef = selected.originalObject.id;

      this.$parent.OrderCtrl.getAddress(selected.originalObject.hrLocation);
    }
  }

  getAddress(hrLocation) {

    let deferred = this.$q.defer();
    let self = this;
    let params = {
      hrLocation: hrLocation,
      _pageSize: 'All',
      _selector: 'hrLocation,displayAddress',
      _sortBy: 'hrLocation asc'
    };
    this.$http.get(`/api/types/companies/addresses`, { params: params })
      .then(function(response) {
        if(response.data && response.data.length) {
          self.form.facilityAddress = response.data[0].displayAddress;
        }
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  locationCode_clearInput(id) {
    this.$scope.$broadcast('autocomplete:clearInput', id);
    this.form.locationCode = null;
    this.form.locationCodeRef = null;
  }

  // Job Class

  jobClass_formatter(items) {
    try {
      let formattedItems = [];
      let i;
      let titles = [];
      for(i in items) {
        titles = [];
        if(items[i].name) {
          titles.push(items[i].name);
        }
        if(items[i].description) {
          titles.push(items[i].description);
        }
        formattedItems.push({
          id: items[i]._id,
          title: titles.join(' / ')
        });
      }
      return formattedItems;
    } catch(err) {
      console.log(err);
      return;
    }
  }

  jobClass_showAll(id) {
    this.$scope.$broadcast('autocomplete:showAll', id);
  }

  jobClass_onChanged(input) {
    this.$parent.OrderCtrl.form.jobClass = input;
  }

  jobClass_onSelected(selected) {
    if(selected) {
      this.$parent.OrderCtrl.form.jobClass = selected.title;
      this.$parent.OrderCtrl.form.jobClassRef = selected.originalObject.id;
    }
  }

  jobClass_clearInput(id) {
    this.$scope.$broadcast('autocomplete:clearInput', id);
    this.form.jobClass = null;
    this.form.jobClassRef = null;
  }

  /* 
   * Start
   */

  $onInit() {
    let self = this;
    this.Auth.getCurrentUser().then(function(user) {
      self.user = user;
      self.form.requestedBy = user.name;
      if(self.$stateParams.id) {
        self.isAdd = false;
        self.getData(self.$stateParams.id);
      }
    });
  }
}

export default angular.module('wftOrderFormApp.order', [uiRouter])
  .config(routes)
  .component('order', {
    template: require('./order.html'),
    controller: OrderComponent,
    controllerAs: 'OrderCtrl'
  })
  .controller('ExportModalController', ExportModalController)
  .name;



// WEBPACK FOOTER //
// ./client/app/order/order.component.js